// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
import { InvoiceBlockRulesFragment } from '../../fragments/generated/invoice-block-rules.fragment.generated';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type GetAllInvoiceBlocksQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetAllInvoiceBlocksQueryResult = { __typename?: 'Query', getAllInvoiceBlocks: { __typename?: 'InvoiceBlockRulesDTO', blockOptional: boolean, blocks: Array<string> } };

export const GetAllInvoiceBlocksGql = gql`
    query GetAllInvoiceBlocks {
  getAllInvoiceBlocks {
    ...InvoiceBlockRules
  }
}
    ${InvoiceBlockRulesFragment}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllInvoiceBlocksInjectable extends Apollo.Query<GetAllInvoiceBlocksQueryResult, GetAllInvoiceBlocksQueryVariables> {
    override document = GetAllInvoiceBlocksGql;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
/* eslint-enable */